/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { sortByTitle } from './helpers/sortByTitle';

export const listProductTypes = createAsyncThunk(
  'productTypes/list',
  async (_payload, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.productTypes.list();
      return data || [];
    } catch (error) {
      Logger.error(new Error('Error product types fetching'), { error }, [
        'ListProductTypesFailed',
        { errorMessage: 'Product types can not be fetched from backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(listProductTypes.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase(listProductTypes.fulfilled, (state, { payload }) => {
      state.items = sortByTitle(payload);
      state.isLoading = false;
      state.isLoaded = true;
    })
    .addCase(listProductTypes.rejected, (state, { error }) => {
      state.isLoading = false;
      state.error = error;
    });
};
